'use client';

import {QueryClient, QueryClientProvider} from 'react-query';
import {SetCurrentPage} from '@/components/SetCurrentPage';
import React, {useEffect} from 'react';
import {Locale} from "@/i18n/i18n-config";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import BugsnagPerformance from "@bugsnag/browser-performance";
import {Provider} from 'jotai'

const queryClient = new QueryClient();

interface ProvidersProps {
    children: React.ReactNode;
    lng: Locale,
    env: {
        bugsnagKey: string;
        env: 'production' | 'development' | 'test';
        title: string;
    }
}

export function Providers({children, lng, env}: ProvidersProps) {

    useEffect(() => {

        Bugsnag.start({
            apiKey: env?.bugsnagKey ? env?.bugsnagKey : 'NO_KEY',
            plugins: [new BugsnagPluginReact()],
            releaseStage: 'production',
            metadata: {
                company: {
                    name: env.title,
                }
            }
        })

        BugsnagPerformance.start({apiKey: env?.bugsnagKey ? env?.bugsnagKey : 'NO_KEY'});

    }, []);


    const ErrorBoundary = Bugsnag?.isStarted() && Bugsnag?.getPlugin('react')?.createErrorBoundary(React)

    const providers = <Provider>
        <SetCurrentPage currentPage="default"></SetCurrentPage>
        <QueryClientProvider client={queryClient}>
            {children}
        </QueryClientProvider>
    </Provider>

    if (!ErrorBoundary) {
        return providers
    }

    return (
        <ErrorBoundary>
            {providers}
        </ErrorBoundary>
    );
}